export const environment = {
  placement: "prod",
  production: true,
  route_hash: false,
  timezone: "America/Argentina/Buenos_Aires",
  code: "AR",
  currency: "ARS",
  country_code: "+54",
  gateway: {
    base_url: "https://services.rappi.com.ar",
  },
  currencySymbol: "$",
  country: {
    defaultLocale: "es-AR",
  },
  localeUrl: "https://cargo-core-api.s3.amazonaws.com/ar/cargo-logos/",
  oAuth: {
    client_id: "C5Ej64OTPM2AV9tpBHwXRMgFB2QIJw0bbPeKDg0v",
    redirect_uri: "https://turbo-wms.rappi.com.ar",
    response_type: "code",
    scope: "all",
    flowName: "GeneralOAuthFlow",
  },
  OAuthGateway: "https://www.rappi.com.ar/login-legacy",
  userToken: "xxxxxxxxxx",
  auth0: {
    domain: "turbo-prod.us.auth0.com",
    clientId: "BTnFLZUnsZdSKLTepEo8MgipWk1Kkrm4",
    redirectUri: "https://turbo-wms.rappi.com.ar",
  },
  nexusHubUrl: "https://turbo-nexus-hub.rappi.com/",
};
